import React from 'react';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import {useTranslation} from 'react-i18next';
type Props = {
   onOk: () => void;
   disabled?: boolean;
   children?: React.ReactNode;
   content?: React.ReactNode;
   title?: string;
};

const ConfirmationWrapper: React.FC<Props> = (props) => {
   const {t} = useTranslation();
   const {children, onOk, disabled, content = t('Confirm?'), title = t('Confirmation')} = props;
   const [isOpened, open] = React.useState(false);

   return (
      <>
         <span onClick={() => !disabled && open(true)}>{children}</span>
         {isOpened ? (
            <ConfirmationDialog
               onOk={() => {
                  open(false);
                  onOk();
               }}
               onCancel={() => {
                  open(false);
               }}
               content={content}
               title={title}
            />
         ) : null}
      </>
   );
};

export default ConfirmationWrapper;
